import PersonalGreeting from "./PersonalGreeting";
import MyStory from "./MyStory";
import GetInTouch from "./GetInTouch";
import { Container } from "@mui/material";

function Aboutme() {
  return (
    <Container maxWidth="lg" sx={{ my: 5 }}>
      <PersonalGreeting />
      <MyStory />
      <GetInTouch />
    </Container>
  );
}

export default Aboutme;
